<div class="row">
    <div class="col-12 mt-5 movieTemplate">
        <div class="paneles">
            <div class="row">
                <div class="col-12 px-xl-5">

                    <div class="card text-white mb-4">
                        <div class="card-body">
                            <div class="titulo-fo-about">Sobre Félix Oliver</div>
                            <p class="texto">
                                Félix Oliver, sala virtual de la plataforma +Cinemateca, es un espacio de exhibición por
                                streaming que completa lo que
                                sucede en las salas de cine. Dentro de la plataforma +Cinemateca se buscará reunir a la
                                producción audiovisual nacional,
                                desde los primeros registros hasta el cine más reciente. Podremos encontrar cine
                                uruguayo; el viejo y el nuevo; largos,
                                cortos y mediometrajes; documentales y ficciones; series, entrevistas, fragmentos de
                                material de archivo; posters,
                                reseñas e información sobre equipos de trabajo.
                            </p>
                            <p class="texto">
                                En un hito histórico para el cine de nuestro país en donde ASOPROD, Cinemateca Uruguaya,
                                Montevideo Audiovisual y TCC se
                                unen para encontrar una respuesta a la pregunta: ¿Dónde está el cine uruguayo? Hoy
                                unimos fuerzas para promover una
                                herramienta que facilite el acceso a nuestro cine, generando un modelo de múltiples
                                pantallas que trascienda los límites
                                montevideanos y logre que todos los uruguayos puedan ver el cine que se hace acá, en
                                buena calidad y reconociendo el
                                trabajo de sus realizadores.
                            </p>
                            <p class="texto">
                                Hemos compartido la preocupación sobre cuál es el recorrido que hace el cine de
                                nuestro país y dónde es posible
                                encontrarlo cuando queremos verlo después de terminada su vida natural en las salas de
                                cine. ¿Cuál es el camino que
                                transitan las películas uruguayas, qué oportunidades y canales tienen, qué
                                características poseen esas ventanas? Pero
                                también, ¿cuál es el camino a seguir para quien quiere ver o volver a ver cine
                                nacional y debe navegar en busca de
                                copias de mala calidad o tratar de que un realizador gentilmente le facilite esa
                                solución?

                            </p>
                            <p class="texto">
                                Para fortalecer el lugar que ocupa el cine uruguayo es que surge Felix Oliver y por lo
                                que busca transformarse en “el
                                lugar del cine uruguayo” bajo el calificado cuidado de su anfitrión, y que los distintos
                                protagonistas de este proyecto
                                buscan apuntalar, cada uno desde su lugar. Así como Cinemateca es conocida como la sala
                                del cine uruguayo, Félix
                                Oliver viene a fortalecer ese espacio; Asoprod, bajo su marca CineUy, buscando ampliar y
                                mejorar la distribución y
                                exhibición del cine nacional en esta oportunidad con el apoyo de los Fondos de Incentivo
                                Cultural (FIC) que permiten
                                sumar socios y colaboradores a la iniciativa, como lo es la empresa de cable TCC y su
                                canal de streaming para abonados
                                “Vivo Acá”, espacio dedicado a las realizaciones nacionales. A estos cuatro actores del
                                sector privado, se le suma la
                                apuesta de Montevideo Audiovisual de la Intendencia de Montevideo, quien ha encontrado
                                en esta iniciativa, puntos de
                                acuerdo para continuar su importante tarea de promoción de la producción y exhibición
                                del cine nacional.

                            </p>
                            <p class="texto">
                                Esta plataforma busca garantizar los mejores estándares de calidad de sus contenidos y
                                la rigurosidad en la
                                información que los acompaña. Trabajamos en la búsqueda de los formatos originales,
                                telecinando otros y tratando de
                                poner a disposición su mejor versión. Algunos contenidos serán de acceso gratuito y
                                otros pagos que garantizarán a
                                los realizadores y productores el correspondiente ingreso económico que reporten sus
                                visualizaciones.

                            </p>
                            <p class="texto">
                                Elegimos este nombre como forma de reconocer a uno de los pioneros del cine uruguayo,
                                quien proveniente de Europa a
                                fines del siglo XIX, llegó con una cámara, un proyector y rollos de película y fue
                                quien realizó los primeros
                                registros fílmicos en Uruguay. Registros que hoy guarda el archivo fílmico de
                                Cinemateca.

                            </p>
                            <p class="texto">
                                La sala Félix Oliver estará, además, integrada a la base de datos Cinestrenos desde
                                1929 creada por Osvaldo
                                Saratsola. Una sistematización de información del cine nacional que necesita que se le
                                de el valor y reconocimiento
                                que le corresponde.

                            </p>
                            <p class="texto">
                                Otro valor que tiene esta propuesta es que todo el proyecto implica actores uruguayos,
                                las películas estarán alojadas
                                dentro del sitio mascinemateca.org.uy, en el data center de Uruguay, con soporte en
                                nuestro país y en nuestro idioma.
                                El contenido estará seguro, geolocalizado para nuestro territorio, resguardado con los
                                parámetros exigidos por los
                                principales prestadores de VOD.

                            </p>
                            <p class="texto">
                                El contenido se estructurará en dos grandes categorías: estrenos y catálogo. El
                                primero corresponde a películas que
                                recientemente bajaron de las salas de Cine, allí podrá encontrarse el contenido que
                                solo podrá verse en modalidad PPV
                                con un costo de $190. Luego, el resto de los contenidos tendrán un costo de visionado
                                por PPV de $125 o la posibilidad
                                de elegir una tarifa mensual de suscripción de $120 (con un mínimo de 3 meses).

                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>